window.addEventListener("load",function(event) {
  
  var number = document.getElementById('SingleOptionSelector-0');
  var initials = document.getElementById('SingleOptionSelector-1');
  
  console.log('number ' + number.value)
  
  if(initials != null && (initials.value == 'no' || initials.value == 'No' || initials.value == 'NO')) {
    document.getElementById('initials_label').style.display = "none";
  	document.getElementById('initials_input').style.display = "none"; 
    document.getElementById('initials_input').setAttribute("disabled", "disabled");
    document.getElementById("initials_input").value = "";
  }
  
  if(number != null && (number.value == 'no' || number.value == 'No' || number.value == 'NO')) {
    document.getElementById('number_label').style.display = "none";
  	document.getElementById('number_input').style.display = "none"; 
    document.getElementById('number_input').setAttribute("disabled", "disabled");
    document.getElementById("number_input").value = "";
  }
  
  
  if(initials != null) {
    initials.addEventListener('change',function(e){
      if(initials.value == 'Yes' || initials.value == 'yes' || initials.value == 'YES') {
         document.getElementById('initials_label').style.display = "block";
         document.getElementById('initials_input').style.display = "block"; 
         document.getElementById('initials_input').removeAttribute('disabled');

      } else if(initials.value == 'no' || initials.value == 'No' || initials.value == 'NO') { 
         document.getElementById('initials_label').style.display = "none";
         document.getElementById('initials_input').style.display = "none"; 
         document.getElementById('initials_input').setAttribute("disabled", "disabled");
         document.getElementById("initials_input").value = "";

      } else {
          document.getElementById('initials_label').style.display = "none";
          document.getElementById('initials_input').style.display = "none"; 
          //document.getElementById("initials_input").value = "";
          document.getElementById('initials_input').setAttribute("disabled", "disabled");
      }
    });
  }
  
  if(number != null) {
    number.addEventListener('change',function(e){
      if(number.value == 'Yes' || number.value == 'yes' || number.value == 'YES') {
        document.getElementById('number_label').style.display = "block";
         document.getElementById('number_input').style.display = "block"; 
         document.getElementById('number_input').removeAttribute('disabled');

      } else if(number.value == 'no' || number.value == 'No' || number.value == 'NO') { 
         document.getElementById('number_label').style.display = "none";
         document.getElementById('number_input').style.display = "none"; 
         document.getElementById('number_input').setAttribute("disabled", "disabled");
         document.getElementById("number_input").value = "";

      } else {
          document.getElementById('number_label').style.display = "none";
          document.getElementById('number_input').style.display = "none"; 
          document.getElementById('number_input').setAttribute("disabled", "disabled");
          //document.getElementById("number_input").value = "";
      }
    });
  }
  
},false);

window.addEventListener( "pageshow", function ( event ) {
  var historyTraversal = event.persisted || ( typeof window.performance != "undefined" && window.performance.navigation.type === 2 );
  if ( historyTraversal ) {
    window.location.reload();
  }
});